import { AxiosError } from 'axios';
import { authHeader } from 'services';
import { Api } from './api/axios.service';

const getDashboard = async (): Promise<any> => {
  try {
    const { data } = await Api.get<any>(`/dashboard`, {
      headers: { ...authHeader() },
    });

    return data;
  } catch (reason) {
    const { response } = reason as AxiosError<{ error: string }>;
    throw new Error(
      response?.data?.error || 'Não foi possível listar o relatório'
    );
  }
};

const getDashboardByPlan = async (planId: string): Promise<any> => {
  try {
    const { data } = await Api.get<any>(`/dashboard/tutorPlan/${planId}`, {
      headers: { ...authHeader() },
    });
    return data;
  } catch (reason) {
    const { response } = reason as AxiosError<{ error: string }>;
    throw new Error(
      response?.data?.error || 'Não foi possível listar o relatório'
    );
  }
};

const getDashboardNumbersByPlan = async (planId: string): Promise<any> => {
  try {
    const { data } = await Api.get<any>(`/dashboard/tutorPlanNumbers/${planId}`, {
      headers: { ...authHeader() },
    });
    return data;
  } catch (reason) {
    const { response } = reason as AxiosError<{ error: string }>;
    throw new Error(
      response?.data?.error || 'Não foi possível listar o relatório'
    );
  }
};

const getPlans = async (): Promise<any> => {
  try {
    const { data } = await Api.get<any>(`/dashboard/plans`, {
      headers: { ...authHeader() },
    });
    return data;
  } catch (reason) {
    const { response } = reason as AxiosError<{ error: string }>;
    throw new Error(
      response?.data?.error || 'Não foi possível listar o relatório'
    );
  }
};



export const DashboardService = {
  getDashboard,
  getDashboardByPlan,
  getPlans,
  getDashboardNumbersByPlan
};

